import { render, staticRenderFns } from "./SubjectMappingTable.vue?vue&type=template&id=2164f016&scoped=true&"
import script from "./SubjectMappingTable.vue?vue&type=script&lang=js&"
export * from "./SubjectMappingTable.vue?vue&type=script&lang=js&"
import style0 from "./SubjectMappingTable.vue?vue&type=style&index=0&id=2164f016&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164f016",
  null
  
)

export default component.exports